import React, { useEffect } from 'react'
import { Grid } from '@mui/material'
import aquaparkPng from 'assets/pictures/aquapark.png'
import discord from 'assets/pictures/discord.png'
import { toast } from 'react-toastify'
import { keys } from 'lodash'
import { useDispatch } from 'react-redux'
import { discordLogin, startWaiting, stopWaiting } from 'app/appSlice'
import { useNavigate } from 'react-router'
import { myUrl } from 'conf/basepath'
import { URL_WANTED } from 'common/constants/Constants'

const LoginApp = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const onOpenDiscord = () => {
        const redirectDiscord = `https://discord.com/oauth2/authorize?client_id=1278714443995414601&redirect_uri=${encodeURI(myUrl)}&response_type=token&scope=email+identify`
        const opts = {
            toolbar: 'no',
            location: 'no',
            directories: 'no',
            status: 'no',
            menubar: 'no',
            scrollbars: 'no',
            resizable: 'no',
            copyhistory: 'no',
            width: 700,
            height: 900,
            top: (screen.height/2)-450,
            left: (screen.width/2)-350,
        }
        const windowFeatures = keys(opts).map(key => `${key}=${opts[key]}`).join(',')
        const loginWindow = window.open(
            redirectDiscord,
            '_blank',
            windowFeatures,
        )
        if (!loginWindow) {
            toast.error('La fenêtre de connexion n\'a pas pu être ouverte')
        }
    }

    useEffect(() => {
        const onReceiveToken = (event) => {
            if (event.origin !== window.location.origin) return

            const { type, token } = event.data
            if (type === 'loginDiscordSuccess') {
                dispatch(startWaiting())
                dispatch(discordLogin(token)).then(payload => {
                    dispatch(stopWaiting())
                    if (payload.meta.requestStatus === 'fulfilled') {
                        const wantedUrl = localStorage.getItem(URL_WANTED)
                        if (wantedUrl && wantedUrl !== '') {
                            localStorage.removeItem(URL_WANTED)
                            const strangeUrl = wantedUrl.startsWith('tp://') || wantedUrl.startsWith('tps://') ? '/' : wantedUrl
                            const formatWanted = strangeUrl.startsWith('/') ? strangeUrl : `/${strangeUrl}`
                            navigate(formatWanted)
                        } else navigate('/')
                    }
                })
            }
        }

        window.addEventListener('message', onReceiveToken)

        return () => {
            window.removeEventListener('message', onReceiveToken)
        }
    }, [dispatch])

    return (
        <Grid container alignItems='center' justifyContent='center' style={{ minHeight: '100vh', backgroundImage: `url(${aquaparkPng})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '100vh' }}>
            <Grid size='auto'>
                <div
                    onClick={onOpenDiscord}
                    style={{
                        alignItems: 'center',
                        color: '#fff',
                        backgroundColor: '#1e1f22',
                        borderRadius: 4,
                        display: 'inline-flex',
                        fontSize: 18,
                        fontWeight: 600,
                        height: 56,
                        justifyContent: 'center',
                        width: 276,
                        cursor: 'pointer',
                    }}
                >
                    <img src={discord} style={{ height: 40, width: 40, marginRight: 12 }}/>
                    Sign in with Discord
                </div>
            </Grid>
        </Grid>
    )
}

export default LoginApp